import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import i18next from "i18next";
import { Product } from "./Interfaces";

export interface ExcelProduct extends Omit<Product, 'category'> {
	categoryName: string;
	errors?: string[];
}

interface ProductSimpleTableVerticalProps {
	products: ExcelProduct[];
	startRowIndex?: number;
	fontSize?: string;
}

export const ProductSimpleTableVertical = (props: ProductSimpleTableVerticalProps) => {
	const { products: ps, fontSize = '0.8rem' } = props;
	const product = ps[0]; // 첫 번째 상품만 표시

	const confirmDialogFontSize = fontSize;

	const fields = [
		// { key: 'categoryName', label: i18next.t('product_category.product_type') },
		{ key: 'curriculumName', label: i18next.t('product.curriculum_name') },
		{ key: 'volume', label: i18next.t('product.volume') },
		{ key: 'title', label: i18next.t('common.title') },
		{ key: 'code', label: i18next.t('product.subject_code') },
		{ key: 'price', label: i18next.t('product.price') }
	];

	return (
		<TableContainer>
			<Table size="small">
				<TableBody>
					{fields.map((field) => {
						const { errors } = product;
						const bgColor = errors?.includes(field.key) ? 'rgba(255, 0, 0, 0.1)' : 'transparent';

						return (
							<TableRow key={field.key}>
								<TableCell
									sx={{
										maxWidth: 50,
										backgroundColor: '#f5f5f5',
										fontWeight: 'bold',
										fontSize: confirmDialogFontSize
									}}
								>
									{field.label}
								</TableCell>
								<TableCell
									sx={{
										backgroundColor: bgColor,
										fontSize: confirmDialogFontSize,
										// ...(field.key === 'price' && { textAlign: 'right' })
									}}
								>
									{field.key === 'price' && product[field.key]
										? i18next.t('common.price_yen', { price: product[field.key].toLocaleString() })
										: product[field.key] || '-'}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);
};